module.exports = __webpack_public_path__ + "static/media/Video Player (1).de14dba7.svg";